import axiosInstance from "../api/axiosInstance";
import { showErrorToast } from "../components/ConfirmDialog";

const TTL_MS = 60 * 60 * 1000;
const blobCache = new Map();

function revokeIfExpired(key, now = Date.now()) {
  const hit = blobCache.get(key);
  if (!hit) return;
  if (hit.expiresAt <= now) {
    URL.revokeObjectURL(hit.url);
    blobCache.delete(key);
  }
}

export async function openCachedAttachment(cacheKey, fetchUrl) {
  if (!cacheKey || !fetchUrl) return;
  const now = Date.now();
  revokeIfExpired(cacheKey, now);

  const hit = blobCache.get(cacheKey);
  if (hit?.url) {
    window.open(hit.url, "_blank", "noopener,noreferrer");
    return;
  }

  try {
    const res = await axiosInstance.get(fetchUrl, { responseType: "blob" });
    const type = res.headers["content-type"] || "application/pdf";
    const blob = new Blob([res.data], { type });
    const url = URL.createObjectURL(blob);
    blobCache.set(cacheKey, { url, expiresAt: now + TTL_MS });
    window.open(url, "_blank", "noopener,noreferrer");
  } catch (err) {
    showErrorToast(
      err?.response?.data?.message || "Không thể mở file đính kèm."
    );
  }
}

export function openAdvanceAttachment(advanceId) {
  if (!advanceId) return Promise.resolve();
  return openCachedAttachment(
    `advance:${advanceId}`,
    `/finance/advance-requests/${advanceId}/attachment`
  );
}
